import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// React-shared.
import SharedActionSelect from '@exonet/react-shared/lib/data-manager/elements/ActionSelect';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// Styled.
import * as S from './styled';

const ActionSelect = ({ onChange = () => {}, options = [], disabled = false }) => {
  const { t } = useTranslation();

  const select = (
    <SharedActionSelect
      searchable={false}
      onChange={onChange}
      options={options}
      placeholder={
        <>
          <FontAwesomeIcon icon={byPrefixAndName.fal.gear} size="lg" />
          <S.Label>{t('core:common.actions')}</S.Label>
        </>
      }
    />
  );

  if (!disabled) {
    return select;
  }

  return <S.Disabled>{select}</S.Disabled>;
};

ActionSelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
};

export default ActionSelect;
